import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActionType } from '../../../assets/constants/constants';
import { AppContext } from '../../../context/AppProvider';
import { authSession, clearLocalStorage, logOut } from '../../../lib/utils';
import { useTranslation } from 'react-i18next';

const SignOut = () => {
  const {i18n} = useTranslation();
  const {  dispatch } = useContext(AppContext);
  const navigate = useNavigate();
  const params = new URLSearchParams(window?.location?.search);
  const languageParam = params.get("language");

  useEffect(() => {
    if(languageParam) {
      localStorage.setItem('i18nextLng', languageParam?.split("-")[0]);
      localStorage.setItem('locale', languageParam);
      i18n.changeLanguage(languageParam?.split("-")[0]);
      params.delete('language');
    }
    const checkUser = async() => {
      const accessToken = await authSession();
      if(accessToken !== undefined) {
        // User is logged in, so log them out
        await logOut();
      }
      clearLocalStorage();
      dispatch({ type: ActionType.CLEAR_CONTEXT, payload: true });
      // Logout the user and redirect to the login page
      navigate("/");
    }
    checkUser()
  }, []);
  return (
    <>
      {/* <CustomLogin /> */}
    </>
  );
};

export default SignOut;
